import { render, staticRenderFns } from "./TheTopButton.vue?vue&type=template&id=af504f5c"
import script from "./TheTopButton.vue?vue&type=script&lang=js"
export * from "./TheTopButton.vue?vue&type=script&lang=js"
import style0 from "./TheTopButton.vue?vue&type=style&index=0&id=af504f5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports